import { CouponList } from "./views";

import { Route } from "react-router-dom";

export const COUPON_ROUTES = [
    <Route path="/coupon" element={<CouponList />} />,
];

export { CouponList } from "./views";
